import React from "react";
import Header from "../menu/Header";
import { BiLink } from "react-icons/bi";
import { FaGithub } from "react-icons/fa";
import userData from "../../constants/userData";
import Footer from "../Homepage/Footer";
import "./webapps.css";

export default function Webapps() {
  return (
    <div className="">
      <Header />
      <h2 className="text-3xl font-bold mt-10 text-center">Projects</h2>
      <div className="mx-10 flex flex-col md:flex-row md:flex-wrap">
        {userData.projects.map((exp) => {
          return (
            <div className="project-box md:w-1/3 py-4 px-4">
              <img src={`../images/${exp.imgUrl}`} alt="" />
              <h2 className="title">{exp.title}</h2>
              <ul className="icon">
                {exp.github && (
                  <li>
                    <a
                      href={exp.github}
                      without
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <FaGithub
                        size="30"
                        className="flex justify-center items-center"
                      />
                    </a>
                  </li>
                )}
                <li>
                  <a
                    href={exp.link}
                    without
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <BiLink
                      size="30"
                      className="flex justify-center items-center"
                    />
                  </a>
                </li>
              </ul>
            </div>
          );
        })}
      </div>
      <Footer />
    </div>
  );
}
